import React, { useCallback } from 'react';
import EditShareableLinkContext from './EditShareableLink.context';
import { DataRoomShareableLink } from 'models/ShareableLink';
import ShareableLinkDrawer from '../../components/DataRoomDocumentsRouter/components/ShareableLinkDrawer';
import ShareableFilesSelectModal from '../../components/DataRoomDocumentsRouter/components/ShareableFilesSelectModal';
import useShareableLink from '../../hooks/useShareableLink';

type EditShareableLinkProps = {
  updateShareableLink?: (data: DataRoomShareableLink) => void;
};

const EditShareableLink: React.FC<EditShareableLinkProps> = (props) => {
  const { children, updateShareableLink } = props;

  const {
    drawer,
    selectedLink,
    modalNodes,
    isLoading,
    checkedFileIds,
    checkedFolderIds,
    initiallyCheckedNodes,
    drawerRef,
    modalRef,
    setSelectedLink,
    openModal,
    onCloseDrawer,
    onModalFilesSelect,
  } = useShareableLink();

  const openEditShareableLink = useCallback(
    (link: DataRoomShareableLink) => {
      setSelectedLink(link);
      drawer?.setOpen(true);
    },
    [drawer, setSelectedLink],
  );

  return (
    <EditShareableLinkContext.Provider value={{ openEditShareableLink }}>
      {children}

      <ShareableLinkDrawer
        ref={drawerRef}
        isEdit
        checkedFileIds={checkedFileIds}
        checkedFolderIds={checkedFolderIds}
        link={selectedLink}
        onFilesReselect={openModal}
        onSuccessLink={updateShareableLink}
        closeAction={onCloseDrawer}
      />

      <ShareableFilesSelectModal
        ref={modalRef}
        nodes={modalNodes}
        isLoading={isLoading}
        initiallyCheckedNodes={initiallyCheckedNodes}
        onFilesSelect={onModalFilesSelect}
      />
    </EditShareableLinkContext.Provider>
  );
};

export default EditShareableLink;
